import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';

import * as _ from 'lodash';
import * as moment from 'moment';
import { NzModalService } from 'ng-zorro-antd';
import { TranslateService } from '@ngx-translate/core';
import { FileUploader, FileItem } from 'ng2-file-upload';

import { environment } from '../../../../environments/environment';
import { RegisterService } from '../../services/register.service';
import { Observable } from 'rxjs/Observable';
import { LoginService } from '../../services/login.service';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {
    @ViewChild('uploadImg') uploadImg: ElementRef;
    @ViewChild('uploadDoc') uploadDoc: ElementRef;
    @ViewChild('uploadOtherFile') uploadOtherFile: ElementRef;

    // form状态: true:显示form  false:显示提交成功
    registerPeriod = 1;
    showForm = true;
    registerForm1: FormGroup;
    registerForm2: FormGroup;
    smCode: string;
    picUrl: string;
    templateName: string;
    templateUrl: string;
    hasFile: boolean;
    imageCode: string;

    imgUploader: any;
    docUploader: any;
    otherFileUploader: any;
    imgUrl = '';
    imgFileName = '';
    fileName = '';
    otherFileName = '';
    imgFormatWrong = false;
    imgFormatLegalList = ['JPG', 'JPEG', 'PNG', 'BMP', 'GIF'];
    imgFilePath = '';
    docFormatWrong = false;
    docFormatLegalList = ['XLS', 'XLSX'];
    docFilePath = '';
    otherFormatWrong = false;
    otherFilePath = '';
    companyInfo: any;
    protocolText = '';
    areaValue = [];
    businessValue = [];
    areaOptions = [{
        value: 'zhejiang',
        label: 'Zhejiang',
        children: [{
            value: 'hangzhou',
            label: 'Hangzhou',
            children: [{
                value: 'xihu',
                label: 'West Lake'
            }],
        }, {
            value: 'ningbo',
            label: 'Ningbo',

        }],
    }, {
        value: 'jiangsu',
        label: 'Jiangsu',
        children: [{
            value: 'nanjing',
            label: 'Nanjing',
            children: [{
                value: 'zhonghuamen',
                label: 'Zhong Hua Men',

            }],
        }],
    }];
    businessOptions = [{
        value: 'zhejiang',
        label: 'Zhejiang',
        children: [{
            value: 'hangzhou',
            label: 'Hangzhou',
            children: [{
                value: 'xihu',
                label: 'West Lake',

            }],
        }, {
            value: 'ningbo',
            label: 'Ningbo',

        }],
    }, {
        value: 'jiangsu',
        label: 'Jiangsu',
        children: [{
            value: 'nanjing',
            label: 'Nanjing',
            children: [{
                value: 'zhonghuamen',
                label: 'Zhong Hua Men',

            }],
        }],
    }];
    showSelectError = false;
    businessMap = {};
    businessList = [];

    constructor(
        // private ref: ElementRef,
        private router: Router,
        private modal: NzModalService,
        private fb: FormBuilder,
        private regService: RegisterService,
        private translate: TranslateService,
        private loginService: LoginService
    ) { }

    buildAreaTree(index, list, map, tree) {
        let item = list[index];
        if (map[item.id]) {
            return true;
        }
        if (map[item.id] === null) {
            return false;
        }
        if (item.parentId == 0) {
            let o = {
                value: item.name,
                label: item.name,
                isLeaf: true
            }
            tree.push(o);
            map[item.id] = o;
            return true;
        }
        let ix;
        for (let i = 0; i < list.length; ++i) {
            if (list[i].id == item.parentId) {
                ix = i;
                break;
            }
        }
        if (ix == null) {
            map[item.id] = null;
            return false;
        }
        if (this.buildAreaTree(ix, list, map, tree)) {
            let o = map[item.parentId],
                no = {
                    value: item.name,
                    label: item.name,
                    isLeaf: true
                };
            if (o.isLeaf) {
                delete o.isLeaf;
                o.children = [];
            }
            o.children.push(no);
            map[item.id] = no;
            return true;
        } else {
            return false;
        }
    }

    buildBusinessTree(index, list, map, tree) {
        let item = list[index];
        if (map[item.id]) {
            return true;
        }
        if (map[item.id] === null) {
            return false;
        }
        if (item.parentId == 0) {
            let o = {
                value: item.id,
                label: item.name,
                isLeaf: true
            }
            tree.push(o);
            map[item.id] = o;
            return true;
        }
        let ix;
        for (let i = 0; i < list.length; ++i) {
            if (list[i].id == item.parentId) {
                ix = i;
                break;
            }
        }
        if (ix == null) {
            map[item.id] = null;
            return false;
        }
        if (this.buildBusinessTree(ix, list, map, tree)) {
            let o = map[item.parentId],
                no = {
                    value: item.id,
                    label: item.name,
                    isLeaf: true
                };
            if (o.isLeaf) {
                delete o.isLeaf;
                o.children = [];
            }
            o.children.push(no);
            map[item.id] = no;
            return true;
        } else {
            return false;
        }
    }

    confirmSelect() {
        if (!this.areaValue.length || !this.businessValue.length) {
            this.showSelectError = true;
            return;
        }
        this.showSelectError = false;
        let area = this.areaValue.join('/'),
            business = this.businessValue.map(item => this.businessMap[item].label).join('/');
        if (this.businessList.some(item =>
            item.area === area && item.business === business
        )) {
            this.modal.warning({
                title: this.translate.instant('common.warn'),
                content: '不要重复添加营业范围类型'
            });
            return;
        }
        this.businessList.push({
            area,
            business,
            businessRange: this.areaValue.join(''),
            firstBusinessId: this.businessValue[0],
            secondBusinessId: this.businessValue[1] || ''
        });
        // this.areaValue = [];
        // this.businessValue = [];
    }

    ngOnInit() {
        this.regService.getProtocol().subscribe(data => {
            this.protocolText = data.protocolText;
        });
        this.registerForm1 = this.fb.group({
            name: [null, [Validators.required, this.nameValidator, Validators.maxLength(50)]],
            mobilePrefix: ['+86'],
            mobile: [null, [Validators.required, this.mobileValidator]],
            phoneNumber: [null, [Validators.required, this.phoneNumberValidator]],

            username: [null, [Validators.required, this.userNameValidator], [this.checkLoginName]],
            email: [null, [Validators.required, Validators.maxLength(50), this.emailValidator]],
            password: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
            checkPassword: [null, [Validators.required, this.confirmationValidator]]
        });
        this.registerForm2 = this.fb.group({
            supplierName: [null, [Validators.required]],
            supplierType: [null, [Validators.required]],
            foundTime: [null, [Validators.required, this.foundTimeValidator]],
            registeredCapital: [null, [Validators.required]],
            assetSize: [null],
            staffSize: [null, this.intValidator],
            keyAccounts: [null],
            summary: [null, [Validators.required, Validators.maxLength(600)]],
            onMarket: [null, [Validators.required]],
            onMarketArea: [null],
            registerAddress: [null, [Validators.required]],
            workAddress: [null, [Validators.required]],
            // supplierCode: [null, [Validators.required, Validators.maxLength(10)]],
            // businessCode: [null, [Validators.required]],
            // taxpayerIdentification: [null, [Validators.required]],
            businessLicenceUrl: [null, [Validators.required]],
            socialCreditCode: [null, [Validators.required, this.socialCreditCodeValidator]],
            // businessLicenceUrl: [null, [Validators.required]],
            qualificationAuditUrl: [null, [Validators.required]],
            otherFileUrl: [null]
        });
        this.getTemplate();
        this.regService.getArea().subscribe(list => {
            this.areaOptions = [];
            let map = {};
            for (let i = 0; i < list.length; ++i) {
                this.buildAreaTree(i, list, map, this.areaOptions);
            }
        });
        this.regService.getBusinessType().subscribe(list => {
            this.businessOptions = [];
            this.businessMap = {};
            for (let i = 0; i < list.length; ++i) {
                this.buildBusinessTree(i, list, this.businessMap, this.businessOptions);
            }
        });
        this.createImgUploader();
        this.createDocUploader();
        this.createOtherFileUploader();
        setTimeout(() => {
            this.changePicCode();
        });
        this.loginService.getCompanyInfo().toPromise().then(x => {
            this.companyInfo = x[0];
        });
    }

    goToPeriod(index) {
        this.registerPeriod = index;
    }

    enquiry() {
        this.router.navigate(['/price/enquiry-public'], {
            queryParams: { 'date': new Date().getTime() }
        });
    }

    copyWorkAddress() {
        let registerAddress = this.registerForm2.controls['registerAddress'].value;
        let workAddress = this.registerForm2.controls['workAddress'].value;
        if (!workAddress) {
            this.registerForm2.controls['workAddress'].setValue(registerAddress);
        }
    }

    removeImgFile() {
        this.imgUrl = '';
        this.imgFileName = '';
        this.imgFilePath = '';
        this.registerForm2.controls['businessLicenceUrl'].setValue('');
    }
    removeDocFile() {
        this.fileName = '';
        this.docFilePath = '';
        this.registerForm2.controls['qualificationAuditUrl'].setValue('');
    }
    removeOtherFile() {
        this.otherFileName = '';
        this.otherFilePath = '';
    }
    validateForm1() {
        for (const i in this.registerForm1.controls) {
            if (this.registerForm1.controls.hasOwnProperty(i)) {
                this.registerForm1.controls[i].markAsDirty();
            }
        }
        return this.registerForm1.valid;
    }

    validateForm2() {
        for (const i in this.registerForm2.controls) {
            if (this.registerForm2.controls.hasOwnProperty(i)) {
                this.registerForm2.controls[i].markAsDirty();
            }
        }
        if (this.registerForm2.controls['businessLicenceUrl'].hasError('required')) {
            this.modal.error({
                title: this.translate.instant('common.error'),
                content: '请上传营业执照,并再次提交'
            });
            return false;
        } else if (this.registerForm2.controls['qualificationAuditUrl'].hasError('required')) {
            this.modal.error({
                title: this.translate.instant('common.error'),
                content: '请上传资质审核文件,并再次提交'
            });
            return false;
        }
        return this.registerForm2.valid;
    }

    _submitForm() {
        if (this.registerForm1.valid && this.registerForm2.valid) {
            if (!this.imageCode || !this.imageCode.trim().length) {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: '请填写验证码'
                });
                return;
            }
            if (!this.imageCode.trim().match(/^[0-9A-Z]{6}$/)) {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: '请填写正确格式的验证码'
                });
                return;
            }
            const val1 = this.registerForm1.value,
                val2 = this.registerForm2.value;
            const body = {
                imageCode: this.imageCode,
                username: val1.username,
                name: val1.name,
                email: val1.email,
                mobile: val1.mobile,
                officePhone: val1.phoneNumber,
                password: val1.password,

                supplierName: val2.supplierName,
                companyType: val2.supplierType,
                establishDate: moment(val2.foundTime).format('YYYY-MM') + '-01',
                registAddress: val2.registerAddress,
                officeAddress: val2.workAddress,
                list: val2.onMarket ? 'Y' : 'N',
                listAddress: val2.onMarket ? (val2.onMarketArea || '') : '',

                registAmount: val2.registeredCapital,
                assetSize: val2.assetSize || '',
                staffSize: val2.staffSize || '',
                importantClient: val2.keyAccounts || '',
                companyProfile: val2.summary,
                // supplierCode: val.supplierCode,
                // businessCode: val2.businessCode,
                // taxpayerIdentification: val2.taxpayerIdentification,
                businessLicenceUrl: val2.businessLicenceUrl,
                socialCreditCode: val2.socialCreditCode,
                qualificationAuditUrl: val2.qualificationAuditUrl,
                otherFileUrl: val2.otherFileUrl || '',
                business: JSON.stringify(this.businessList, ['businessRange',
                    'firstBusinessId',
                    'secondBusinessId'])
            };

            this.regService.register(body).toPromise().then(res => {
                if (res) {
                    this.showForm = false;
                }
            }, err => {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: err
                });
                this.imageCode = '';
                this.changePicCode();
            });
        }
    }

    socialCreditCodeValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        } else if (!control.value.match(/^[0-9A-Z]{18}$/)) {
            return { format: true, error: true };
        }
    }

    updateConfirmValidator() {
        /** wait for refresh value */
        setTimeout(() => {
            this.registerForm1.controls['checkPassword'].updateValueAndValidity();
        });
    }

    intValidator = (control: FormControl): { [s: string]: boolean } => {
        if (control.value && control.value.toString().indexOf('.') != -1) {
            return { int: true, error: true }
        }
    }

    userNameValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value) {
            return { required: true };
        }
        const length = control.value.trim().length;
        if (length == 0) {
            return { required: true };
        }
        if (length < 6 || length > 20) {
            return { length: true, error: true };
        }
    }

    nameValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value || !control.value.trim()) {
            return { required: true };
        }
    }

    confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value || !control.value.trim()) {
            return { required: true };
        } else if (control.value !== this.registerForm1.controls['password'].value) {
            return { confirm: true, error: true };
        }
    }

    emailValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value || !control.value.trim()) {
            return { required: true };
        } else if (!control.value.trim().match(/^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/)) {
            return { format: true, error: true };
        }
    }

    mobileValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value || !control.value.trim()) {
            return { required: true };
        } else if (!control.value.trim().match(/^(13|14|15|17|18|19)[0-9]{9}$/)) {
            return { format: true, error: true };
        }
    }

    phoneNumberValidator = (control: FormControl): { [s: string]: boolean } => {
        if (!control.value || !control.value.trim()) {
            return { required: true };
        } else if (!control.value.trim().match(/^0\d{2}-\d{8}(-\d{1,4})?$|^0\d{3}-\d{7,8}(-\d{1,4})?$/)) {
            return { format: true, error: true };
        }
    }

    foundTimeValidator = (control: FormControl): { [s: string]: boolean } => {
        if (control.value) {
            const value = moment(control.value).format('YYYY-MM');
            const now = moment(new Date()).format('YYYY-MM');
            if (value > now) {
                return { afterNow: true, error: true };
            }
        }
    }

    // 校验登录名是否被使用
    checkPhoneRepeat = (control: FormControl): Observable<ValidationErrors> => {
        return this.regService.checkPhone({ mobile: control.value })
            .map(res => null)
            .catch(err => Observable.of({ repeat: true, error: true }));
    }

    // 校验登录名是否被使用
    checkLoginName = (control: FormControl): Observable<ValidationErrors> => {
        return this.regService.checkLoginName({ username: control.value })
            .map(res => null)
            .catch(err => Observable.of({ sameLoginName: true, error: true }));
    }

    getFormControl1(name) {
        return this.registerForm1.controls[name];
    }

    getFormControl2(name) {
        return this.registerForm2.controls[name];
    }

    getYearMonth(m) {
        return moment(m).format('YYYY-MM');
    }

    sendSmCode(event) {
        // 发送短信验证码
        this.smCode = '423423';
    }

    getTemplate() {
        const code = 'supplier_doc';
        this.regService.getTemplateInfo(code).toPromise().then(data => {
            this.hasFile = !!data.filePath;
            this.templateName = data.fileName || '没有文件或文件无法下载';
            this.templateUrl = `${environment.urlBase}api/open/srm/file/download?id=${data.filePath}`;
            this.registerForm2.patchValue({ businessLicenceUrl: data.filePath });
        });
    }

    changePicCode() {
        // 刷新图形验证码
        this.picUrl = environment.urlBase + 'api/open/srm/srmSupplierAudit/getValidateCode?date=' + new Date().getTime();
    }

    jump2Index() {
        this.router.navigate(['login']);
    }
    //#region upload

    createImgUploader() {
        const uploader = new FileUploader({
            method: 'POST',
            url: `${environment.urlBase}api/open/srm/file/upload`,
            autoUpload: false
            // allowedFileType: ['image']
        });
        // 本方法用于拼接额外传输参数
        // uploader.onBuildItemForm = (fileItem: FileItem, form: any) => {
        //     console.log(fileItem, form);
        // };
        uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
            // console.log('item uploaded' + response);
            if (status === 200) {
                // 上传文件后获取服务器返回的数据
                const data = JSON.parse(response);
                if (data.body) {
                    const info = data.body.toString().split('|');
                    if (info.length >= 2) {
                        const businessLicenceUrl = `${environment.urlBase}api/open/srm/file/download?id=${info[0]}`;
                        this.registerForm2.patchValue({ businessLicenceUrl: businessLicenceUrl });
                        this.imgUrl = businessLicenceUrl;
                        this.imgFileName = info[1];
                    }
                }
            } else {
                // 上传文件后获取服务器返回的数据错误
                console.log('上传失败:', response);
            }
        };
        uploader.onErrorItem = (item: any, response: string, status: number, headers: any): any => {
            console.log('item error' + response);
        };
        uploader.onCompleteAll = () => {
            uploader.clearQueue();
        };
        this.imgUploader = uploader;
    }

    createOtherFileUploader() {
        const uploader = new FileUploader({
            method: 'POST',
            url: `${environment.urlBase}api/open/srm/file/upload`,
            autoUpload: false
            // allowedFileType: ['image']
        });
        // 本方法用于拼接额外传输参数
        // uploader.onBuildItemForm = (fileItem: FileItem, form: any) => {
        //     console.log(fileItem, form);
        // };
        uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
            // console.log('item uploaded' + response);
            if (status === 200) {
                // 上传文件后获取服务器返回的数据
                const data = JSON.parse(response);
                if (data.body) {
                    const info = data.body.toString().split('|');
                    if (info.length >= 2) {
                        const otherFileUrl = `${environment.urlBase}api/open/srm/file/download?id=${info[0]}`;
                        this.registerForm2.patchValue({ otherFileUrl: otherFileUrl });
                        this.otherFileName = info[1];
                    }
                }
            } else {
                // 上传文件后获取服务器返回的数据错误
                console.log('上传失败:', response);
            }
        };
        uploader.onErrorItem = (item: any, response: string, status: number, headers: any): any => {
            console.log('item error' + response);
        };
        uploader.onCompleteAll = () => {
            uploader.clearQueue();
        };
        this.otherFileUploader = uploader;
    }

    createDocUploader() {
        const uploader = new FileUploader({
            method: 'POST',
            url: `${environment.urlBase}api/open/srm/file/upload`,
            autoUpload: false
            // allowedFileType: ['pdf', 'doc', 'xls', 'ppt', 'compress']
        });
        // 本方法用于拼接额外传输参数
        // uploader.onBuildItemForm = (fileItem: FileItem, form: any) => {
        //     console.log(fileItem, form);
        // };
        uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => {
            if (status === 200) {
                // 上传文件后获取服务器返回的数据
                const data = JSON.parse(response);
                if (data.body) {
                    const info = data.body.toString().split('|');
                    if (info.length >= 2) {
                        const qualificationAuditUrl = `${environment.urlBase}api/open/srm/file/download?id=${info[0]}`;
                        this.registerForm2.patchValue({ qualificationAuditUrl: qualificationAuditUrl });
                        this.fileName = info[1];
                    }
                }
            } else {
                // 上传文件后获取服务器返回的数据错误
                console.log('上传失败:', response);
            }
        };
        uploader.onErrorItem = (item: any, response: string, status: number, headers: any): any => {
            console.log('item error' + response);
        };
        uploader.onCompleteAll = () => {
        };
        this.docUploader = uploader;
    }

    imgFileNameValidate(imgFilePath) {
        const formatPos = imgFilePath.lastIndexOf('.') + 1,
            formatName = imgFilePath.slice(formatPos);
        return this.imgFormatLegalList.some(item => formatName.toUpperCase() === item);
    }

    selectedImgFileOnChanged(ev) {
        if (this.uploadImg.nativeElement.files.length) {
            if (this.uploadImg.nativeElement.files[0].size > 10 * 1024 * 1024) {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: '文件大小需小于10M'
                });
                return;
            }
        }
        if (this.imgFilePath.length === 0) {
            this.imgFilePath = this.uploadImg.nativeElement.value;
        }
        this.imgFormatWrong = !this.imgFileNameValidate(this.imgFilePath);
        if (this.imgFormatWrong) {
            return;
        }
        this.imgFileName = '';
        this.registerForm2.patchValue({ businessLicenceUrl: '' });
        this.uploadFile(this.imgUploader);
    }

    selectedOtherFileOnChanged(ev) {
        if (this.uploadOtherFile.nativeElement.files.length) {
            if (this.uploadOtherFile.nativeElement.files[0].size > 20 * 1024 * 1024) {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: '文件大小需小于20M'
                });
                return;
            }
        }
        if (this.otherFilePath.length === 0) {
            this.otherFilePath = this.uploadOtherFile.nativeElement.value;
        }

        this.otherFileName = '';
        this.registerForm2.patchValue({ otherFilePath: '' });
        this.uploadFile(this.otherFileUploader);
    }

    docFileNameValidate(docFilePath) {
        const formatPos = docFilePath.lastIndexOf('.') + 1,
            formatName = docFilePath.slice(formatPos);
        return this.docFormatLegalList.some(item => formatName.toUpperCase() === item);
    }

    selectedDocFileOnChanged(ev) {
        if (this.uploadDoc.nativeElement.files.length) {
            if (this.uploadDoc.nativeElement.files[0].size > 10 * 1024 * 1024) {
                this.modal.error({
                    title: this.translate.instant('common.error'),
                    content: '文件大小需小于10M'
                });
                return;
            }
        }
        if (this.docFilePath.length === 0) {
            this.docFilePath = this.uploadDoc.nativeElement.value;
        }
        this.docFormatWrong = !this.docFileNameValidate(this.docFilePath);
        if (this.docFormatWrong) {
            return;
        }
        this.fileName = '';
        this.registerForm2.patchValue({ qualificationAuditUrl: '' });
        this.uploadFile(this.docUploader);
    }

    uploadFile(uploader) {
        // 正在上传和上传完成的不再上传
        const list = uploader.queue.filter(x => !x.isUploading && !x.isUploaded);
        if (list && list.length) {
            _.each(list, x => {
                x.upload(); // 开始上传
            });
        }
    }

    get year() {
        return { year: moment().year() };
    }

    get website() {
        if (this.companyInfo) {
            if (_.startsWith(this.companyInfo.website, 'http://')) {
                return this.companyInfo.website;
            }
            return 'http://' + this.companyInfo.website;
        }
        return 'javascript://void(0);';
    }
    //#endregion

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/register/register.component.ts